import type { DesignAsset, BoundIntent } from '../../types/design'
import { formAdapter } from './formAdapter'
import { checklistAdapter } from './checklistAdapter'
import { automationAdapter } from './automationAdapter'

export type MaterializationContext = {
  workspaceId: string
  actor: { id: string; name: string }
}

export type MaterializationSuccess<TDraft> = {
  ok: true
  draft: TDraft
  warnings: string[]
}

export type MaterializationFailure = {
  ok: false
  errors: string[]
}

export type MaterializationResult<TDraft> = MaterializationSuccess<TDraft> | MaterializationFailure

export type MaterializationAdapter<TDraft> = {
  kind: BoundIntent
  supportedRoles: string[]
  run: (asset: DesignAsset, ctx: MaterializationContext) => MaterializationResult<TDraft>
}

const registry = new Map<BoundIntent, MaterializationAdapter<unknown>>()

const register = <TDraft>(adapter: MaterializationAdapter<TDraft>) => {
  registry.set(adapter.kind, adapter as MaterializationAdapter<unknown>)
}

register(formAdapter)
register(checklistAdapter)
register(automationAdapter)

export const getMaterializationAdapter = <TDraft>(
  kind: BoundIntent,
): MaterializationAdapter<TDraft> | null =>
  (registry.get(kind) as MaterializationAdapter<TDraft> | undefined) ?? null

export { formAdapter, checklistAdapter, automationAdapter }
